import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100 container-fluid p-0" }
const _hoisted_2 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_3 = { class: "text-center pt-8 px-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "mt-4 mb-3",
  "data-test": "error-screen-header"
}
const _hoisted_6 = { class: "mx-auto mw-480 guide" }

import errorImgSrc from '@grantstreet/govhub-vue/src/assets/error-page-illustration.svg'
import Copyright from '@grantstreet/govhub-vue/src/components/Copyright.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadFailure',
  props: {
  translationKey: {
    type: String,
    default: 'loadFailure',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("img", {
          class: "img-fluid align-middle border-0",
          src: _unref(errorImgSrc)
        }, null, 8, _hoisted_4),
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t(`error.${__props.translationKey}.title`)), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t(`error.${__props.translationKey}.desc`)), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`error.${__props.translationKey}.guide`)), 1)
      ])
    ]),
    _createVNode(Copyright, { class: "mt-auto" })
  ]))
}
}

})